<template>
  <div class="wrapper-navbar pb-4 flex-grow-1 px-4" :class="theme">
    <b-row class="align-items-center text-white pt-2 pb-4 mx-lg-5 m-0">
      <div class="d-flex gap-2 align-items-center">
        <span
          v-if="!hideBackButton"
          class="material-icons float-left cursor d-lg-none font-weight-bolder"
          @click="$router.go(-1)"
        >
          keyboard_arrow_left
        </span>
        <b-avatar v-if="theAvatarMustBeDisplayed" size="lg" :src="childSelectedAvatar"></b-avatar>
        <span class="title d-none d-md-block font-weight-bolder mx-0">
          {{ title }}
        </span>
        <span class="title d-md-none font-weight-bolder">
          {{ title }}
        </span>
      </div>
    </b-row>
  </div>
</template>

<script>
import NotificationsHeaderPopup from '@/notifications/components/NotificationsHeaderPopup.vue';
import { getThemeColor } from '@/common/utils';
import { useSessionStore } from '@/common';

export default {
  components: {
    NotificationsHeaderPopup,
  },
  data() {
    const sessionStore = useSessionStore();
    return {
      sessionStore,
    };
  },
  props: {
    title: String,
    router: String,
    hideBackButton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    theme() {
      return `bg-${getThemeColor(this.sessionStore.themeSelection)}`;
    },
    userIsAParent() {
      return this.sessionStore.userIsAParent;
    },
    theAvatarMustBeDisplayed() {
      return (
        (this.sessionStore.childSelectedId.length && this.userIsAParent) || !this.userIsAParent
      );
    },
    childSelectedAvatar() {
      return this.sessionStore.getCurrentChild.avatar;
    },
  },
};
</script>
<style lang="scss" scoped>
.title {
  letter-spacing: 0.7px;
}
</style>
